import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { LoggerService } from '@telespot/shared/logger/feature/util';
import { apiUrl } from '@telespot/shared/environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

export interface RoiItem {
  id: string;
  sampleId: string;
  assetId: string;
  analysisId: string;
  findingId: string;
  findingVersionId: string;
  creatorEntity: string;
  creatorId: string;
  stepId: string;
  pipelineId: string;
  filename: string;
  cropFile?: string;
  findingVersion: number;
  x0: number;
  y0: number;
  x1: number;
  y1: number;
  //Review
  labels: { [key: string]: number };
  score: number;
}
export interface RoisResponse {
  items: RoiItem[];
  nextToken?: string;
}

export interface CategoryLabelData {
  uuid: string;
  color: string;
  crops: CropInfo[];
}

export interface CropRegion {
  assetId: string;
  x0: number;
  x1: number;
  y0: number;
  y1: number;
}

export interface CropInfo {
  roiID: string;
  findingId: string;
  crop: Observable<SafeUrl>;
  score: number;
}

@Injectable({
  providedIn: 'root',
})
export class MosaicService {
  constructor(private _http: HttpClient, private _logger: LoggerService, private sanitizer: DomSanitizer) { }

  async getRoisFromSample(
    subjectId: string,
    creatorId: string,
    limit = 100,
    label: string,
    nextToken?: string
  ): Promise<RoisResponse> {
    try {
      const endpoint = `samples/${subjectId}/rois`;
      let baseUrl = `${apiUrl('mosaics')}/${endpoint}?creator=${creatorId}&limit=${limit}`;

      if (label) {
        baseUrl = baseUrl + `&label=${label}`;
      }

      const url = nextToken ? baseUrl + `&nextToken=${nextToken}` : baseUrl;

      return this._http.get<RoisResponse>(url).toPromise();
    } catch (err) {
      this._logger.error('[Mosaic service] - Error rois', err.message);
      throw err;
    }
  }

  getCrop(region: CropRegion): Observable<Blob> {
    const { assetId, x0, x1, y0, y1 } = region;
    const endpoint = `assets/${assetId}/crops`;
    const params = new HttpParams({ fromObject: { x0, x1, y0, y1 } });
    const url = `${apiUrl('mosaics')}/${endpoint}?${params.toString()}`;
    const headers = new HttpHeaders({ Accept: 'image/jpeg, */*' });
    return this._http.get(url, { headers: headers, responseType: 'blob' });
  }

  getCropSanitizedUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
}
